import React, { useEffect } from 'react'
import './AuditTable.css'
import { Table, notification, Button, Row, Col, } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { fetchTodayBestTokens } from '../../Redux/TodayBestTokensSlice'
import MarketCap from '../MarketCap/MarketCap'
import RiskLevel from '../RiskLevel/RiskLevel'
import Badges from '../Badges/Badges'
import moment from 'moment'
import VoteButton from '../VoteButton/VoteButton'
import TokenName from '../TokenName/TokenName'
import Chain from '../Chain/Chain'

function TokensData() {

    // table data related variables
    const { loading, data, error } = useSelector((state) => state.todayBestTokens)
    const dispatch = useDispatch()

    // antd notifications without duplicating
    const notificatioKey = 'error';

    // fetch data from API
    useEffect(() => {
        dispatch(fetchTodayBestTokens())
    }, [dispatch])

    // error nofitications
    useEffect(() => {
        if (error) {
            notification['error']({
                key: notificatioKey,
                message: 'Oops!',
                description: error
            });
        }
    }, [error])

    // columns related data
    const columns = [
        {
            key: "id",
            title: 'No',
            dataIndex: "id",
            render: (_, record, index) => (index + 1),
        },
        {
            key: "name",
            title: 'Name',
            fixed: 'left',
            dataIndex: "name",
            render: (_, record) => (
                <TokenName id={record.id} tokenName={record.name} tokenSymbol={record.symbol} logoLink={record.logo_link} coingecko_link={record.coingecko} coinmarketcap_link={record.coinmarketcap} />
            ),
        },
        {
            key: "chain",
            title: "Chain",
            dataIndex: "chain",
            render: (_, record, index) => (
                <Chain tokenData={record} />
            ),
        },
        {
            key: "market_cap",
            title: 'Market Cap',
            render: (_, record) => <span className='marketcap-text'><MarketCap address={record.bsc_contract_address ? record.bsc_contract_address : record.ethereum_contract_address}  chain={record.bsc_contract_address ? 'bsc' : 'eth'} /></span>,
        },
        {
            key: "released_on",
            title: 'Released',
            render: (_, record) => <span>{moment(record.release_date).fromNow()}</span>,
        },
        {
            key: "risk_level",
            title: 'Risk Level',
            render: (_, record) => <RiskLevel riskLevel={record.risk_level} />,
        },
        {
            key: "Badges",
            title: 'Badges',
            dataIndex: "badges",
            render: (_, record) => <div>
                <Badges isAudited={record.is_audited} riskLevel={record.risk_level}  />
            </div>
        },
        {
            key: "votes",
            title: 'Votes',
            dataIndex: "vote_count",
            render: (_, record) => <div>
                <VoteButton voteCount={record.vote_count} isVoted={record.is_voted} dispatchEvent={fetchTodayBestTokens()} coinID={record.id} />
            </div>
        }
    ];

    return (
        <div className='table'>
            <div className='table-responsive'>
                <Table
                    rowClassName={(record, index) => index % 2 === 0 ? 'table-row-light' :  'table-row-dark'}
                    size='small'
                    columns={columns}
                    dataSource={data}
                    pagination={false}
                    loading={loading}
                />
            </div>
        </div>
    )
}

export default TokensData